import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const context = createContext({ isInGroup: false });
const GroupProvider = ({ children }) => {
    return jsx(context.Provider, Object.assign({ value: { isInGroup: true } }, { children: children }));
};
const useGroup = () => {
    return useContext(context);
};

export { GroupProvider as default, useGroup };
//# sourceMappingURL=GroupProvider.js.map
